"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const roving_focus_controller_1 = require("@/controllers/roving-focus-controller");
require("@/components/common/text/semantics/heading");
// 각 항목이 shadow 안에 렌더하는 포커스 대상. 행 조립 규칙은 menu-item 계열이 소유한다.
const ITEM_SELECTOR = '[role^="menuitem"], [role="radio"]';
/**
 * menu-item 계열 행을 묶어 방향키로 순회하는 목록. heading을 주면 목록 위에 소제목을 함께 보여준다.
 * menu·radiogroup은 항목 역할만 자식으로 가질 수 있어 소제목을 제목 요소로 읽히게 두지 않고,
 * 화면에만 그린 뒤 같은 문구를 목록의 aria-label로 옮긴다(mm-form-field의 label과 같은 방식).
 */
let MenuItemGroup = class MenuItemGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.role = 'menu';
        this.size = 'medium';
        this.rovingFocus = new roving_focus_controller_1.RovingFocusController(this, {
            getItems: () => this.items,
            orientation: 'vertical',
            getActiveIndex: () => this.items.findIndex(item => item.getAttribute('aria-checked') === 'true'),
            onFocusMove: index => this.selectFocusedRadio(index),
        });
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderHeading()}
      <div class="items"><slot @slotchange=${this.handleSlotChange}></slot></div>
    `;
    }
    willUpdate(changed) {
        if (!changed.has('heading'))
            return;
        if (this.heading) {
            this.setAttribute('aria-label', this.heading);
            return;
        }
        this.removeAttribute('aria-label');
    }
    // 목록 표면이 열릴 때 선택된 항목(없으면 첫 항목)으로 포커스를 옮긴다.
    focus() {
        this.rovingFocus.focusTabStop();
    }
    renderHeading() {
        if (!this.heading)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-heading level="5" aria-hidden="true">${this.heading}</mm-heading>
    `;
    }
    // radiogroup은 방향키로 포커스를 옮기면 그 항목이 곧 선택된다. 선택은 행의 활성화 경로를 그대로 탄다.
    selectFocusedRadio(index) {
        if (this.role !== 'radiogroup')
            return;
        this.items[index]?.click();
    }
    get items() {
        return this.slotElements
            .map(element => element.shadowRoot?.querySelector(ITEM_SELECTOR))
            .filter((item) => !!item);
    }
    // 항목은 자기 shadow를 렌더한 뒤에야 포커스 대상이 생기므로, 렌더가 끝난 뒤 tab stop을 다시 맞춘다.
    async handleSlotChange() {
        await Promise.all(this.slotElements.map(element => element.updateComplete));
        this.requestUpdate();
    }
};
MenuItemGroup.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-1);
    }

    .items {
      display: flex;
      flex-direction: column;
    }

    :host([size='large']) .items {
      gap: var(--space-2);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], MenuItemGroup.prototype, "role", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], MenuItemGroup.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MenuItemGroup.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ flatten: true })
], MenuItemGroup.prototype, "slotElements", void 0);
MenuItemGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-menu-item-group')
], MenuItemGroup);
exports.MenuItemGroup = MenuItemGroup;
//# sourceMappingURL=data:application/json;base64,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